import  {baseActions}  from "./base.actions";

export const countyActions = {
   
    gets,
    get,
    
};


function gets() {
    return baseActions.getall('county');
}

function get(id)
{
    return baseActions.get('county',id);
}
